import { Link } from "@tanstack/react-router"
import viri from "../../assets/img/viri.png"

/**
 * Breadcrumb — web3-style breadcrumb bar
 *
 * Dark glass header with optional logo and breadcrumb trail.
 * Defaults to "Viri > text1 > text2". Pass `crumbs` for custom depth.
 *
 * @param {Object} props
 * @param {string} props.text1 - First breadcrumb segment (used when crumbs omitted)
 * @param {string} [props.text2] - Second breadcrumb segment (used when crumbs omitted)
 * @param {string} [props.logo] - Optional logo asset path; falls back to site logo
 * @param {Array<{name:string, url?:string}>} [props.crumbs] - Custom crumb list overriding default trail
 * @returns {React.ReactElement}
 */
function Breadcrumb({ text1, text2, logo, crumbs }: { text1?: string; text2?: string; logo?: string; crumbs?: { name: string; url?: string }[] }) {
  const items = crumbs && crumbs.length
    ? crumbs
    : [
        { name: 'Viri' },
        { name: text1 },
        ...(text2 ? [{ name: text2 }] : []),
      ]

  return (
    <div className="breadcrumb-bar" role="navigation" aria-label="breadcrumb">
      <div className="breadcrumb-content">
        <span className="breadcrumb-logo" aria-hidden="true" />
        <img src={logo || viri} alt="" className="breadcrumb-icon" />
        <nav className="breadcrumb-nav" aria-label="Breadcrumb trail">
          {items.map((crumb, idx) => (
            <span key={idx}>
              {idx > 0 && <span className="breadcrumb-sep">›</span>}
              {crumb.url ? (
                <Link to={crumb.url}>{crumb.name}</Link>
              ) : (
                <span>{crumb.name}</span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </div>
  );
}

export default Breadcrumb;
